import { createGlobalStyle } from 'styled-components';

const StatistiquesProductionStyle = createGlobalStyle`
    .production-page-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        padding: 24px 32px;
        border-radius: 8px;
        margin-bottom: 24px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .production-page-header .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 16px;
    }

    .production-page-header h1 {
        color: white;
        margin: 0;
        font-size: 28px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .production-page-header h1 .anticon {
        font-size: 32px;
    }

    .production-page-header p {
        color: rgba(255, 255, 255, 0.9);
        margin: 8px 0 0 0;
        font-size: 14px;
    }

    .filters-card {
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .filters-card .filter-item {
        width: 100%;
    }

    .filters-card .filter-item label {
        display: block;
        margin-bottom: 8px;
        font-weight: 500;
        color: #262626;
        font-size: 13px;
    }

    .filters-card .filter-item label .anticon {
        margin-right: 6px;
        color: #1890ff;
    }

    .stat-card {
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
        border-left: 4px solid transparent;
    }

    .stat-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    }

    .stat-card:nth-child(1) {
        border-left-color: #1890ff;
    }

    .stat-card:nth-child(2) {
        border-left-color: #52c41a;
    }

    .stat-card:nth-child(3) {
        border-left-color: #ff4d4f;
    }

    .stat-card:nth-child(4) {
        border-left-color: #722ed1;
    }

    .stat-card-highlight {
        background: linear-gradient(135deg, #f0e6ff 0%, #f9f0ff 100%);
    }

    .stat-card .ant-statistic-title {
        font-size: 14px;
        color: #595959;
        font-weight: 500;
    }

    .stat-card .ant-statistic-content {
        font-size: 24px;
        font-weight: 600;
    }

    /* Styles pour les tables */
    .ant-table-thead > tr > th {
        background: #fafafa;
        font-weight: 600;
        color: #262626;
        border-bottom: 2px solid #e8e8e8;
    }

    .ant-table-tbody > tr:hover > td {
        background: #f0f5ff;
    }

    .ant-table-expanded-row > td {
        padding: 0 !important;
    }

    /* Responsive */
    @media (max-width: 768px) {
        .production-page-header h1 {
            font-size: 22px;
        }

        .production-page-header .header-content {
            flex-direction: column;
            align-items: flex-start;
        }

        .stat-card .ant-statistic-content {
            font-size: 20px;
        }
    }

    /* Print styles */
    @media print {
        .layout-menu,
        .navbar,
        .filters-card,
        .production-page-header .ant-space,
        .ant-tabs-nav {
            display: none !important;
        }

        .production-page-header {
            background: white;
            color: black;
            border: 1px solid #d9d9d9;
        }

        .production-page-header h1 {
            color: black;
        }

        .stat-card {
            box-shadow: none;
            border: 1px solid #d9d9d9;
        }

        .ant-table {
            font-size: 10px;
        }
    }
`;

export default StatistiquesProductionStyle;